import axios from 'axios';

const getAllLeftedCartApi = async (paramsFilter, token, langIsoCode) => {
  try {
    const url = `/leftCart/leftCart?store_id=${
      paramsFilter?.store_id || ''
    }&page=${paramsFilter?.page || ''}`;
    const res = await axios.get(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        lang: langIsoCode
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default getAllLeftedCartApi;
